import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import React from "react";
import { BooleanInput, TextInput, required, useMutation, useNotify, useRefresh } from "react-admin";
import ContentAdd from "@material-ui/icons/Add";
import { Form } from "react-final-form";
import SaveIcon from "@material-ui/icons/Save";
import CircularProgress from "@material-ui/core/CircularProgress";

const CustomerUserCreateFormEmptyModal = props => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [mutate, { loading: createLoading }] = useMutation();
  const [open, setOpen] = React.useState(false);

  const handleSubmit = async values => {
    try {
      await mutate(
        {
          type: "create",
          resource: "customerusers",
          payload: { data: { ...values } },
        },
        { returnPromise: true }
      );

      notify("Customer user created", "success");
      handleClose();
      refresh();
    } catch (error) {
      notify("An error occured", "error");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box textAlign="center" m={1}>
      <Typography variant="h4" paragraph>
        No customer user available
      </Typography>
      <Typography variant="body1">You can create a customer user</Typography>
      <Button startIcon={<ContentAdd />} color="primary" onClick={handleClickOpen}>
        Create
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <Form onSubmit={handleSubmit}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <DialogTitle id="form-dialog-title">Create Customer User</DialogTitle>
              <DialogContent>
                <TextInput
                  source="registerId"
                  variant="outlined"
                  label="Register Id"
                  helperText={false}
                  validate={required()}
                  fullWidth
                />
                <TextInput
                  source="ownerCode"
                  variant="outlined"
                  label="Owner Code"
                  helperText={false}
                  validate={required()}
                  fullWidth
                />
                <BooleanInput
                  source="isEditable"
                  variant="outlined"
                  label="Is Editable"
                  initialValue={true}
                  helperText={false}
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Box px={2}>
                  <Button
                    startIcon={
                      createLoading ? <CircularProgress size={18} color="secondary" thickness={2} /> : <SaveIcon />
                    }
                    disabled={createLoading}
                    variant="contained"
                    color="primary"
                    type="submit"
                  >
                    Save
                  </Button>
                </Box>
              </DialogActions>
            </form>
          )}
        </Form>
      </Dialog>
    </Box>
  );
};

export default CustomerUserCreateFormEmptyModal;
